import { render, staticRenderFns } from "./planrele.vue?vue&type=template&id=5168381e&scoped=true&"
import script from "./planrele.vue?vue&type=script&lang=js&"
export * from "./planrele.vue?vue&type=script&lang=js&"
import style0 from "./planrele.vue?vue&type=style&index=0&id=5168381e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5168381e",
  null
  
)

export default component.exports